import React from "react"
import { graphql, useStaticQuery} from "gatsby"
import plantWithLeaves from "../../images/plant_with_leaves.png"
import plantWithBottle from "../../images/plant_with_bottle.png"
import plantWithPot from "../../images/plant_with_pot.png"
import cactus from "../../images/cactus.png"

type Props = {
  index: number
}

const PlaceHolderImage: React.FC<Props> = ({index}) => {
  const placeHolderPics = [plantWithLeaves, plantWithBottle, plantWithPot, cactus]
  const imageSrc = placeHolderPics[index % placeHolderPics.length]

  return(
    <img
      src={imageSrc}
      alt="Placeholder plant image"
      className="article-img-fallback"
      loading="lazy"
    />
  )
}

export default PlaceHolderImage
